module.exports = __webpack_public_path__ + "static/img/icon-instagram.cb5202df.png";